import { SavingGoalsList } from '@/components/saving-goals/SavingGoalsList'
import { Separator } from '@/components/ui/separator'
import { AccountSummary } from '@/components/saving-goals/AccountSummary'

export default function SavingGoalsPage() {
  return (
    <div className="flex-1 overflow-hidden bg-background-primary dark:bg-gradient-to-b dark:from-[#081f3d] dark:to-[#111729]">
      <div className="h-full flex flex-col p-4 sm:p-6 space-y-4 sm:space-y-6">
        {/* Standard Page Header */}
        <div className="flex-shrink-0 border border-border dark:border-border-dark bg-background-secondary/80 dark:bg-background-dark-secondary/80 backdrop-blur-xl backdrop-saturate-150 rounded-2xl shadow-sm">
          <div className="px-4 sm:px-8 py-5 sm:py-6">
            {/* Title Section */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex-shrink-0">
                <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-primary to-secondary dark:from-primary-dark dark:to-secondary-dark bg-clip-text text-transparent">
                  Saving Goals
                </h1>
                <p className="text-sm text-text-secondary dark:text-text-dark-secondary mt-1">
                  Track progress towards your financial goals with dedicated savings accounts
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Accounts summary section with glass effect */}
        <div className="border border-border dark:border-border-dark bg-background-secondary/80 dark:bg-background-dark-secondary/80 backdrop-blur-xl backdrop-saturate-150 rounded-2xl shadow-sm p-4 sm:p-6">
          <AccountSummary />
        </div>
        
        <Separator className="bg-border dark:bg-border-dark" />
        
        {/* Goals list section */}
        <SavingGoalsList />
      </div>
    </div>
  )
} 